  import AppConfig from "config";
import axios from "axios";
const jwtToken = localStorage.getItem('access_token');

const JobsController = {
  async ListJobs(state) {
    try {
      const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `scheduling_page/get_jobs`, {
        state: state
      }, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error("Error fetching transcripts:", error);
      throw error;
    }
  },
  async ListFilesIntegrationXcall() {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO + `scheduling_page/get_integration_xcall`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching transcripts:", error);
      throw error;
    }
  },
  async AddJobs(job_name, audit_id, audit_name, repo_name, repo_path, integration, qtd_protocol, protocol_code, queues, start_date, end_date, ismeta, id_campanha) {
    try {
      const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `scheduling_page/add_jobs`, {
        job_name: job_name,
        audit_id2: audit_id,
        audit_name: audit_name,
        repo_name: repo_name,
        repo_path: repo_path,
        state: 0,
        integration: integration,
        qtd_protocol: qtd_protocol,
        protocol_code: protocol_code,
        queue_id: queues,
        start_date: start_date,
        end_date: end_date,
        ismeta: ismeta,
        id_campanha: id_campanha
      }, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating user:", error);
      throw error;
    }
  },
  async PutJobs(Id, newState) {
    try {
      const response = await axios.put(
        `${AppConfig.BACKEND_URL_REFATORADO}scheduling_page/active_inactive_job/${Id}`,
        { state: newState },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating user:", error);
      throw error;
    }
  },
  async DeleteJobs(Id) {
    try {
      const response = await axios.delete(
        `${AppConfig.BACKEND_URL_REFATORADO}scheduling_page/delete_job/${Id}`,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting user:", error);
      throw error;
    }
  },
  async ListQueues() {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO + `scheduling_page/get_omni_queues`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error("Error fetching transcripts:", error);
      throw error;
    }
  },
  async ListFilesToReprocess() {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO + `scheduling_page/files_reprocess`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error("Error fetching transcripts:", error);
      throw error;
    }
  },
  async Reprocess(idtranscripts, audit_id) {
    try {
      const response = await axios.post(
        AppConfig.BACKEND_URL_REFATORADO + 'scheduling_page/reprocess',
        {
          idtranscripts: idtranscripts,
          audit_id: audit_id
        },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      return response.data.result;
    } catch (error) {
      console.error("Error reprocessing:", error);
      throw error;
    }
  },
  async GetMetadados(job_id) {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO + `metadados_page/get_meta/${job_id}`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error("Error fetching transcripts:", error);
      throw error;
    }
  },
  async AddMetadados(MetaName, DefaultFile, Type, FieldsToExtract, JobID) {
    try {
      const response = await axios.post(
        AppConfig.BACKEND_URL_REFATORADO + `metadados_page/add_meta/${JobID}`,
        {
        meta_name: MetaName,
        default_file: DefaultFile,
        type: Type,
        fields_to_extract: FieldsToExtract,
        job_id: JobID
        },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      return response.data.result;
    } catch (error) {
      console.error("Error reprocessing:", error);
      throw error;
    }
  },
  async DeleteMeta(Id) {
    try {
      const response = await axios.delete(
        AppConfig.BACKEND_URL_REFATORADO + `metadados_page/delete_meta/${Id}`,{
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting user:", error);
      throw error;
    }
  },
  async GetInsights(id_operation) {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO + `insight_page/get_insight/${id_operation}`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error("Error fetching campaigns:", error);
      throw error;
    }
  },
  async GetClassifications(id_campanha) {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO + `classification_page/get_classification/${id_campanha}`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error("Error fetching campaigns:", error);
      throw error;
    }
  },
  async AddInsights(Nome, insight, id_operation) {
    try {
      const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `insight_page/add_insight`, {
        nome: Nome,
        prompt: insight,
        id_operation: id_operation
      
      }, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating user:", error);
      throw error;
    }
  },
  async AddClassification(Nome, classification, id_campanha, id_operation) {
    try {
      const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `classification_page/add_classification`, {
        nome: Nome,
        classificacao: classification,
        id_campanha: id_campanha,
        id_operation: id_operation
      
      }, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating user:", error);
      throw error;
    }
  },
  async DeleteInsight(Id) {
    try {
      const response = await axios.delete(
        AppConfig.BACKEND_URL_REFATORADO + `insight_page/delete_insight/${Id}`,{
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting user:", error);
      throw error;
    }
  },
  async DeleteClassification(Id) {
    try {
      const response = await axios.delete(
        AppConfig.BACKEND_URL_REFATORADO + `classification_page/delete_classification/${Id}`,{
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting user:", error);
      throw error;
    }
  },
};

export default JobsController;